import { TenantClientMapping } from './ApolloProviderWrapper';

export const apolloClientList: TenantClientMapping = {};
